<template>
  <div></div>
</template>

<script>
import { MoveType, Smartbaedal } from '@/plugins/AppManager'

export default {
  name: 'PreOrderLoginContainer',
  computed: {
    isUnSign() {
      return !this.$store.getters.isSign
    },
    isOpenedLoginModal() {
      return this.$store.getters['modal/isOpen'] && this.$store.getters['modal/type'] === 'Login'
    }
  },
  watch: {
    isUnSign(isUnSign) {
      if (isUnSign) this.openModal()
      if (!isUnSign && this.isOpenedLoginModal) this.$store.dispatch('modal/close')
    }
  },
  methods: {
    redirectLoginPage() {
      this.$store.dispatch('modal/close')
      this.$appManager.moveSimple(Smartbaedal.LOGIN, MoveType.PUSH)
    },
    openModal() {
      this.$store.dispatch('modal/open', {
        type: 'Login',
        message: '로그인',
        renderType: 'normal',
        params: {
          onLogin: this.redirectLoginPage
        },
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })
    }
  }
}
</script>

<style scoped></style>
